import React, { useState } from 'react';
import { Modal } from 'antd';
import { Alert, Button } from './ui';

export default function AccountDeletionDialog({ accountId, busy, error, onCancel, onConfirm }) {
  const [disconnect, setDisconnect] = useState(false);
  const [history, setHistory] = useState(false);
  const [confirmationId, setConfirmationId] = useState('');
  const confirmed = disconnect && history && confirmationId.trim() === String(accountId);
  return <Modal title="Удалить аккаунт" open onCancel={onCancel} footer={null}
    closable={!busy} maskClosable={!busy} keyboard={!busy} width={520}>
    <p className="mb-4 text-sm text-gray-600">Аккаунт связан с Messenger. Он будет отключён и убран из списка аккаунтов. История переписки и отправок сохранится.</p>
    {error && <Alert variant="error" className="mb-4">{error}</Alert>}
    <form onSubmit={event => {
      event.preventDefault();
      if (!confirmed || busy) return;
      onConfirm({ confirmation_account_id: Number(accountId), acknowledge_disconnect: disconnect, acknowledge_history: history });
    }} className="space-y-4">
      <label className="flex items-start gap-2 text-sm"><input type="checkbox" disabled={busy} checked={disconnect} onChange={event => setDisconnect(event.target.checked)} />Отключить аккаунт от Telegram и прекратить его работу</label>
      <label className="flex items-start gap-2 text-sm"><input type="checkbox" disabled={busy} checked={history} onChange={event => setHistory(event.target.checked)} />Сохранить историю Messenger</label>
      <label className="block text-sm">Введите ID аккаунта: {accountId}<input value={confirmationId} disabled={busy} onChange={event => setConfirmationId(event.target.value)} inputMode="numeric" autoComplete="off" className="mt-1 block w-full rounded-md border-gray-300" /></label>
      <div className="flex justify-end gap-2"><Button variant="secondary" disabled={busy} onClick={onCancel}>Отмена</Button><Button type="submit" variant="danger" disabled={!confirmed || busy} isLoading={busy}>Удалить аккаунт</Button></div>
    </form>
  </Modal>;
}
